export class HeapApi {
    addEventProperties(attrs: any) {
        window.heap.addEventProperties(attrs)
    }

    addUserProperties(attrs: any) {
        window.heap.addUserProperties(attrs)
    }

    clearEventProperties() {
        window.heap.clearEventProperties()
    }

    identify(uniqueId: string) {
        window.heap.identify(uniqueId)
    }

    resetIdentity() {
        window.heap.resetIdentity()
    }

    removeEventProperty(name: string) {
        window.heap.removeEventProperty(name)
    }

    track(name: string, attrs: any) {
        window.heap.track(name, attrs)
    }
}
